<template>
  <div class="content-wrap">
    <h2>Uitloggen?</h2>
    <p class="light">Als je uit wil loggen kan dat met de onderstaande knop. Tot snel!</p>
    <span
        class="logout btn wide red"
        @click="logout"
    >
      Log uit
    </span>
  </div>
</template>

<script>

import {mapActions} from "vuex";

export default {
  name: "Settings",
  methods: {
    ...mapActions("user", [
      "logout",
    ]),
    ...mapActions("user", [
      "logout",
    ]),
  },
};
</script>
